// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1dcBH","resendInfoText":"OnGoingPaymentBox_resendInfoText__1v-D8"};